<div class="d-flex space-buttons">
  <ng-container *ngIf="!projectHasNonIPBoard">
    <div
      [ngClass]="
        inputProduct.type === PRODUCT_TYPES.IP_BOARD.value
          ? 'selected-button'
          : 'unselected-button'
      "
      class="type-button enabled-button clickable"
      (click)="initializeIPBoard()"
    >
      <div class="button-text">
        <span class="vertical-center-text"
          >Standaard <span class="ip-symbol">IP</span> borden</span
        >
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="projectHasNonIPBoard">
    <div class="type-button disabled-button">
      <div class="button-text">
        <span class="vertical-center-text"
          >Standaard <span class="ip-symbol">IP</span> borden</span
        >
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="!projectHasIPBoard">
    <div
      [ngClass]="
        inputProduct.type === CLIENT_WINDOW_STICKER_TYPE
          ? 'selected-button'
          : 'unselected-button'
      "
      class="type-button enabled-button clickable"
      (click)="initializeWindowSticker()"
    >
      <div class="button-text">
        <span class="vertical-center-text">Raamstickers</span>
      </div>
    </div>
    <div
      [ngClass]="
        inputProduct.type === PRODUCT_TYPES.BOARD.value
          ? 'selected-button'
          : 'unselected-button'
      "
      class="type-button enabled-button clickable"
      (click)="initializeBoard()"
    >
      <div class="button-text">
        <span class="vertical-center-text preserve-line-break"
          >Projectborden&#10;(grotere panelen)</span
        >
      </div>
    </div>
    <div
      [ngClass]="
        inputProduct.type === PRODUCT_TYPES.OTHER_PRODUCT.value
          ? 'selected-button'
          : 'unselected-button'
      "
      class="type-button enabled-button clickable"
      (click)="initializeOtherProduct()"
    >
      <div class="button-text">
        <span class="vertical-center-text">Andere bestellingen</span>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="projectHasIPBoard">
    <div class="type-button disabled-button">
      <div class="button-text">
        <span class="vertical-center-text">Raamstickers</span>
      </div>
    </div>
    <div class="type-button disabled-button">
      <div class="button-text">
        <span class="vertical-center-text"
          >Projectborden&#10;(grotere panelen)</span
        >
      </div>
    </div>
    <div class="type-button disabled-button">
      <div class="button-text">
        <span class="vertical-center-text">Andere bestellingen</span>
      </div>
    </div>
  </ng-container>
  <div class="type-button disabled-button">
    <div class="button-text">
      <span class="vertical-center-text">Zeefdruk</span>
    </div>
  </div>
</div>
